import { Signal } from '@angular/core';
import { AddOn } from '@softline/application';
import { BehaviorSubject, Subject } from 'rxjs';

export interface KommissionierungAddOnParams {
  lagerplatz: Signal<any>;
  bewe: Signal<any>;
  disabled$ : BehaviorSubject<boolean>;
  auftrag: Signal<any>;
  loadLagerplatzVorschlag: (bewe: any) => Promise<void>;
}

export abstract class KommissionierungAddOn extends AddOn<KommissionierungAddOnParams> {}
